/* eslint-disable react/jsx-one-expression-per-line */
import { Main } from './style'
import figura1 from '../../assets/img/dados-figura1.png'
import figura2 from '../../assets/img/dados-figura2.png'
import figura3 from '../../assets/img/dados-figura3.png'
import figura4 from '../../assets/img/dados-figura4.png'

const DadosEcossistema = () => {
    return (
        <Main>
            <div className="container">
                <div>
                    <h1 className="text-center mb-4">Dados do Ecossistema</h1>
                </div>
                <p className="mb-5">
                    Os dados aqui apresentados são baseados na
                    dissertação de Mestrado: Ingrid de Matos Martins.
                    Análise dos Elementos do Ecossistema Empreendedor
                    de Sergipe: Possibilidades e Perspectivas.
                    Dissertação de Mestrado em Administração,
                    Universidade Federal de Sergipe (UFS), Brasil, p. 164, 2020.
                </p>
                <p>
                    O trabalho [Martins 2020] iniciou com a sugestão dada por
                    autores da área de empreendedorismo que indicam que para
                    fortalecer um ecossistema empreendedor deve ser realizado
                    um mapeamento do mesmo. Dessa maneira, após analisar os
                    principais trabalhos da área sobre modelos e elementos
                    chaves em ecossistemas empreendedores, foi possível
                    descobrir os aspectos em comum, e assim propor um modelo
                    que indica os principais atores (ou elementos) que
                    compõem um ecossistema empreendedor. A partir do
                    mapeamento do ecossistema é possível compreender o papel
                    dos atores ali dispostos – considerando as atividades e
                    as responsabilidades de cada ator. Assim, é possível
                    identificar e criar estratégias que se adequem às
                    necessidades do local e, então, o desenvolvimento do
                    ecossistema.
                </p>
                <p>
                    Dessa maneira, foi possível identificar os diferentes
                    atores do ecossistema empreendedor sergipano e fazer
                    uma ligação com cada elemento, em que cada um desempenha
                    seu papel, e também foi realizado um mapeamento inicial
                    das <i>startups</i> localizadas em Sergipe, visto que
                    ainda não há um levantamento que englobe as
                    <i>startups</i> locais, o que dificulta o
                    desenvolvimento do ecossistema local.
                </p>
                <p>
                    Segundo Martins (2020), para realizar esse mapeamento foi
                    utilizada a triangulação de dados, sendo eles: análise de
                    documentos com relatórios de participantes do movimento
                    Inova + Sergipe e do Programa Centelha, além da base de
                    dados da ABStartups (Startupbase), da Startse e do relatório
                    do SEBRAE acerca das <i>startups</i> presentes em Sergipe;
                    observação participante, por meio da participação de eventos
                    em que alguns atores puderam ser notados e destacados; e
                    entrevistas com os gestores das <i>startups</i> e os outros
                    atores, com o objetivo de identificá-los. Sendo assim, foi
                    utilizado o código Atores no <i>NVivo</i> para identificar
                    os atores.
                </p>
                <p>
                    O mapeamento está disposto na Figura 1, com todos os atores
                    que foram identificados durante a execução e análise da
                    pesquisa. Na Figura 1 se observa que há 63 atores no
                    Ecossistema Empreendedor de Sergipe, sendo 6 do elemento
                    Histórias de sucesso, 2 em Redes, 4 Lideranças, 9 no
                    elemento Capital Financeiro, 9 no elemento Capital Humano
                    , 11 no Ambiente regulatório, 2 no elemento Mercados, 16
                    Infraestruturas de apoio e facilitadores e 10
                    correspondentes às Universidades. Salienta-se que os
                    atores “Inova + Sergipe”, Embrapa atuam de duas maneiras
                    – o primeiro como Redes e Liderança e o segundo como
                    Mercados e Ambiente regulatório – conforme foi
                    identificado na análise das entrevistas. A UFS, a Unit
                    e o IFS estão em Universidades e Capital Humano por
                    terem sido destaques nesses elementos e a FASM Invest
                    atua como Capital Financeiro – visto que o objetivo
                    é o investimento – e Infraestrutura de apoio e
                    facilitadores, por fornecer apoio às <i>startups </i>
                    incubadas.
                </p>
                <p className="text-center"><strong>Figura 1</strong> –
                    Mapeamento dos atores do Ecossistema Empreendedor de
                    Sergipe.
                </p>
                <img className="figura1" src={figura1} alt="" />
                <p>
                    As histórias de sucesso mapeadas foram identificadas a
                    partir das entrevistas, foram elas: Pagcerto, Lumengames,
                    Filazero, Quero Delivery, Explicaê e Avonale. No elemento
                    <strong> Atitudes culturais</strong> não tem nenhum ator
                    mapeado, visto que tal elemento não é desenvolvido no
                    estado de Sergipe. Quanto às Redes, foram mapeadas duas:
                    <i> Caju Valley</i> e Inova + Sergipe, conforme depoimentos
                    dos entrevistados e relatório do Inova + Sergipe. Em
                    relação à liderança, o destaque foi para o Inova + Sergipe
                    , visto que os entrevistados afirmaram que o movimento
                    <i> Caju Valley</i> está desativado. Por esse motivo, a
                    pesar de aparecer no mapa, o <i>Caju Valley</i> não está
                    atuando como líder atualmente.
                </p>
                <p>
                    O elemento <strong>Capital Financeiro</strong> foi mapeado
                    por meio das entrevistas (BNB, Banese, Santander, BNDES,
                    FASM Invest) e do Programa Centelha (FAPITEC, CNPq, Confap
                    e FINEP). A FASM Invest, cujo objetivo principal é
                    investir em <i>startups</i>, atua como um <i>hub</i> de
                    inovação, proporcionando assessoria e suporte às
                    <i> startups</i> investidas. O Capital Humano, por sua vez,
                    foi mapeado por meio das entrevistas (Sistema S, Grau
                    Técnico, IFS, UFS e Unit).  Quanto ao ambiente regulatório,
                    apenas a JUCESE e a Embrapa foram mapeadas a partir das
                    entrevistas, os outros fazem parte do movimento Inova +
                    Sergipe (Prefeitura Municipal de Aracaju, o Governo do
                    Estado de Sergipe – por meio da SEDETEC, SEDUC e Seplag, o
                    Governo Federal por meio do MCTIC).
                </p>
                <p>O elemento <strong>Mercados</strong> contém apenas duas
                    empresas, corroborando com as entrevistas que relataram
                    falta de interação entre empresas e <i>startups</i> locais,
                    sendo apenas a Celse – por meio da usina termelétrica – e a
                    Embrapa – por meio de investimento em pesquisa. Com relação
                    às organizações de apoio ao empreendedorismo, todos foram
                    citados e fazem parte do Inova + Sergipe e do Programa
                    Centelha (SEBRAE, Fecomércio, FIES e IEL), enquanto a
                    infraestrutura de apoio e facilitadores foi identificada por
                    meio das entrevistas, exceto a aceleradora Acelerase e a
                    Rede + que fazem parte do Programa Centelha. As profissões
                    de apoio foram mapeadas de acordo com as entrevistas e da
                    observação participante nos eventos, e as Universidades
                    por meio das entrevistas e dos relatórios.
                </p>
                <p>
                    Foi possível observar ainda que alguns dos atores foram
                    citados diversas vezes, o que demonstra o nível de atuação
                    e importância desses atores para o Ecossistema Empreendedor
                    de Sergipe. Por isso, foi utilizada a ferramenta nuvem de
                    palavras no nó referente aos Atores (com documentos do
                    movimento Inova + Sergipe, as entrevistas e a participação
                    em diferentes eventos) para destacar os atores mais citados.
                </p>
                <p>
                    O resultado da utilização dessa ferramenta está exposto na
                    Figura 2. Destaca-se, então, a atuação do SEBRAE (20
                    citações), da UFS (com 17 citações), do movimento Inova +
                    Sergipe (14 citações), da UNIT (14 citações), do Tiradentes
                    Innovation Center (12 citações), do Sergipetec (12
                    citações), da aceleradora Acelerase (9 citações), do
                    <i> Caju Valley</i> (9 citações), Fecomércio (9 citações),
                    Centro de Empreendedorismo da UFS (8 citações) e IFS
                    (7 citações).
                </p>
                <p className="text-center"><strong>Figura 2</strong> –
                    Nuvem de palavras com os atores mais citados do Ecossistema
                    Empreendedor de Sergipe.
                </p>
                <div className="figura2"><img src={figura2} alt="" /></div>
                <p>
                    Com o objetivo de criar uma base de <i>startups</i> ativas,
                    diante da dificuldade encontrada para execução da pesquisa
                    e para estruturar o ecossistema empreendedor local, foram
                    utilizadas quatro fontes de dados para o mapeamento das
                    <i> startups</i>: 1) o relatório do SEBRAE acerca das
                    <i> startups</i> situadas em Sergipe; 2) o <i>site</i> da
                    Startse, com o mapeamento de algumas startups, 3) o
                    <i> site</i> da ABStartups que dispõe de uma comunidade de
                    <i> startups</i> cadastradas e, por fim, 4) da análise das
                    entrevistas.
                </p>
                <p>
                    Para a realização do mapeamento de <i>startups</i>, foi
                    analisado o <i>site</i> de cada uma delas com o objetivo
                    de identificar se estavam ativas, visto que os relatórios
                    constavam unicamente até o ano de 2017. A partir da
                    codificação realizada com o auxílio do software
                    <i> NVivo</i> para o nó Startups, foi possível identificar
                    todas as <i> startups</i> referenciadas nessas fontes de
                    dados. Assim, foi possível desenhar o mapeamento das
                    <i> startups</i> sergipanas de acordo com o seu nicho de
                    mercado, conforme pode-se observar na Figura 3.
                </p>
                <p>
                    Dessa forma, forma identificadas 40 <i> startups</i> ativas
                    no estado de Sergipe, sendo mapeadas de acordo com a área
                    de atuação: Tecnologia da Informação; Meio Ambiente;
                    Finanças (<i>Fintechs</i>); Educação (<i>Edtechs</i>);
                    Saúde e Bem-estar; <i>Games</i>; e Plataformas de Serviços.
                    A maioria das <i> startups</i> sergipanas (15 das 40), de
                    acordo com o mapeamento realizado, atua na área de
                    Tecnologia da Informação, que corresponde às empresas
                    desenvolvedoras de <i>softwares</i> e às <i>startups</i>
                    que oferecem consultoria e suporte relacionados à TI.
                    Outra área de destaque em Sergipe é a de Plataformas de
                    Serviços, que abrange as <i>startups</i> que atuam por meio
                    de uma plataforma – aplicativo, em sua maioria – com o
                    objetivo de prestação de serviços (10 das 40).
                </p>
                <p className="text-center"><strong>Figura 3</strong> –
                    Mapeamento das <i>startups</i> sergipanas ativas
                </p>
                <img className="figura3" src={figura3} alt="" />
                <small>
                    Fonte: Elaborado pela autora com base das entrevistas,
                    relatório do SEBRAE, sites da Startse e ABStartup (2019).
                </small>
                <p className="mt-3">
                    Além do mapeamento e com o objetivo de identificar as
                    <i> startups</i> mais presentes dentre as fontes de dados
                    para o mapeamento das <i> startups</i>, foi utilizada a
                    ferramenta nuvem de palavras do <i>software Nvivo</i>.
                    Pode-se concluir que as <i> startups</i> consideradas
                    casos de sucesso têm maior relevância, por terem sido
                    citadas nas entrevistas, conforme pode-se observar na
                    Figura 4.
                </p>
                <p className="text-center"><strong>Figura 4</strong> –
                    Nuvem de palavras das <i> startups</i> do Ecossistema
                    Empreendedor de Sergipe
                </p>
                <div className="figura4"><img src={figura4} alt="" /></div>
            </div>
        </Main>
    )
}
export default DadosEcossistema
